const licenseTypeEnum = {
    "smsMessagingApi": {
        "name": "Sms Messaging Api",
        "value": 1
    },
    "emailMessagingApi": {
        "name": "Email Messaging Api",
        "value": 2
    },
    "orPortalLicense": {
        "name": "OR Portal License",
        "value": 4
    },
    "layerJotLicense": {
        "name": "LayerJot License",
        "value": 5
    }
};

export default licenseTypeEnum;